"use client";

import Script from "next/script";
import React from "react";
import { GTM_CONTAINER_ID, GTM_SEO_ID, KLAVIYO_PUBLIC_API_KEY } from "constants/site";
import { useUserContext } from "hooks";

const Scripts = () => {
  const { currentUser } = useUserContext();
  const gtmIds = [GTM_CONTAINER_ID, GTM_SEO_ID].filter(Boolean);

  return (
    <>
      {/* only load GTM if we have at least one ID */}
      {gtmIds.length > 0 && (
        <>
          {/* load the gtag library once with the first ID */}
          <Script
            id="gtm-loader"
            src={`https://www.googletagmanager.com/gtag/js?id=${gtmIds[0]}`}
            strategy="afterInteractive"
          />

          {/* configure each GTM ID */}
          <Script id="gtm-config" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){ window.dataLayer.push(arguments); }
              gtag('js', new Date());
              ${gtmIds.map(id => `gtag('config', '${id}');`).join("\n")}
            `}
          </Script>
        </>
      )}
      {KLAVIYO_PUBLIC_API_KEY && (
        <Script
          src={`//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${KLAVIYO_PUBLIC_API_KEY}`}
          strategy="afterInteractive"
          onLoad={() => {
            if (currentUser) {
              // The Klaviyo object is not available immediately after script load, so wait for it
              const id = setInterval(() => {
                if (window.klaviyo) {
                  window.klaviyo.push([
                    "identify",
                    {
                      $email: currentUser.email,
                      $first_name: currentUser.firstName,
                      $last_name: currentUser.lastName,
                      LicenceTypes: currentUser.userFields?.licenseData?.map(
                        licenseData => licenseData?.type
                      ),
                      City: currentUser.userFields?.city,
                      State: currentUser.userFields?.state,
                      ZIP: currentUser.userFields?.zip,
                    },
                  ]);

                  clearInterval(id);
                }
              }, 200);
            }
          }}
        />
      )}
    </>
  );
};

export default Scripts;
